module.exports = __webpack_public_path__ + "static/13_norsk-189ba0944198f87e041274e97ea44a84.png";